import { ApiError } from "../api/api-client";

export function sameAddress(left: string | null | undefined, right: string | null | undefined): boolean {
  return Boolean(left && right && left.toLowerCase() === right.toLowerCase());
}

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.code;
  return error instanceof Error ? error.message : "UNKNOWN_ERROR";
}
